import type { RouteObject } from 'react-router-dom'
import { Company } from '@company//views'

export const CompanyRouter: RouteObject[] = [
  {
    path: '/:slug',
    element: <Company />,
  },
]
